import { render, staticRenderFns } from "./CommitteeCollaborationEvaluation.vue?vue&type=template&id=3f91de99&scoped=true&"
import script from "./CommitteeCollaborationEvaluation.vue?vue&type=script&lang=js&"
export * from "./CommitteeCollaborationEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f91de99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCardTitle,VContainer,VFlex,VIcon,VLayout,VSpacer})
